/**
 * Runtime-injected public client config (`window.__APP_ENV__`).
 *
 * `GET /v2/env.js` (src/app.js, pre-auth) serves this object from the running
 * container because the Nixpacks build bakes no `VITE_*` vars into the bundle
 * (see notes/infra/tier1-remaining-runbook.md § 0). web/index.html loads it as
 * a classic script BEFORE the module bundle, so it is populated by the time
 * lib/sentry.ts + lib/analytics.ts init.
 *
 * Every field is public-by-class client config (browser DSN, PostHog write
 * key, env name, deploy SHA) — the server route whitelists; nothing secret
 * ever rides here. All fields optional: the object is `{}` when the deploy
 * has no telemetry env set, and `undefined` in local dev (the script 404s
 * under `npm run dev`), so callers fall back to `import.meta.env.VITE_*`.
 */
export interface AppEnv {
  sentryDsn?: string;
  sentryEnvironment?: string;
  sentryTracesSampleRate?: string;
  posthogKey?: string;
  release?: string;
  /**
   * Mapbox PUBLIC (`pk.*`) token for the property map's aerial tiles (migration
   * 134). Public-by-class — it rides in tile `<img>` URLs and is restricted at
   * Mapbox by URL, not by hiding it. Absent → the map surface renders its
   * "map unavailable" state and makes no request.
   */
  mapboxToken?: string;
}

declare global {
  interface Window {
    __APP_ENV__?: AppEnv;
  }
}

/** Safe accessor — `{}` when the script didn't load (local dev / tests). */
export function appEnv(): AppEnv {
  return (typeof window !== 'undefined' && window.__APP_ENV__) || {};
}
